'use client';

import { c as _c } from "react/compiler-runtime";
import { useConfig } from '@/hooks/use-config';
import { useProjectsContext } from '@/providers/projects-provider';
import { formatAnalysedDataEndDateForDisplay } from '@/utils/effective-now';
import { cn } from '@/utils/shad';
import { CircleAlert } from 'lucide-react';
const LAST_PROCESSED_BADGE_FG = '#FF6B52';
type AnalysedDataEndDateIndicatorProps = {
  className?: string;
};
export function AnalysedDataEndDateIndicator(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  const {
    projectId,
    selectedProject
  } = useProjectsContext();
  const originalProjectId = selectedProject?.mappedProjectId ?? projectId;
  const {
    data: config
  } = useConfig(originalProjectId);
  const analysedDataEndDate = config?.analysed_data_end_date;
  if (!analysedDataEndDate) {
    return null;
  }
  let t1;
  if ($[0] !== analysedDataEndDate) {
    t1 = formatAnalysedDataEndDateForDisplay(analysedDataEndDate);
    $[0] = analysedDataEndDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  if (!formattedDate) {
    return null;
  }
  let t2;
  if ($[2] !== className) {
    t2 = cn("inline-flex h-7 w-max shrink-0 items-center gap-1.5 rounded-base border border-[#ED512E]/50 bg-[#ED512E]/10 px-2 text-xs font-medium leading-none", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CircleAlert size={12} className="shrink-0" style={{
      color: LAST_PROCESSED_BADGE_FG
    }} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: LAST_PROCESSED_BADGE_FG
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== formattedDate) {
    t5 = <span className="whitespace-nowrap" style={t4}>Last data processed: {formattedDate}</span>;
    $[6] = formattedDate;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}